import React from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.inspections_answer_by_type';
export function PrintNote({ count }) {
    return (React.createElement("div", { className: "qmb-printnote" },
        React.createElement("i", { className: "fa-solid fa-print", "aria-hidden": "true" }),
        React.createElement("span", null,
            React.createElement("b", null, count === 1
                ? translate('print_note.skipped_one', { namespace, count })
                : translate('print_note.skipped_other', { namespace, count })),
            ' ',
            translate('print_note.skipped_body', { namespace }))));
}
